/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* TODO: Add proper typing to resolve type safety warnings */
import { Options } from 'flatpickr/dist/types/options'
import { reportError } from '~/utility/reportError'
import nextArrowImgUrl from '@/assets/images/forward-rounded-dark-blue.svg'

const DATE_PICKER_CONFIG: Options = {
  // https://github.com/ankurk91/vue-flatpickr-component
  // https://flatpickr.js.org/options/
  // https://flatpickr.js.org/formatting/
  allowInput: false,
  altFormat: 'D j M',
  altInput: true,
  animate: true,
  closeOnSelect: false,
  dateFormat: 'Y-m-d',
  inline: true,
  locale: 'en',
  minDate: 'today',
  mode: 'range',
  monthSelectorType: 'static',
  nextArrow: `<img src="${nextArrowImgUrl}">`,
  prevArrow: `<img src="${nextArrowImgUrl}">`,
}

export async function getDatePickerConfig(locale: string): Promise<Options> {
  const config = { ...DATE_PICKER_CONFIG }
  try {
    const currentLanguageCode = locale.split('-')[0]
    config.locale = {
      ...(await loadLocalePackage(currentLanguageCode)),
      firstDayOfWeek: 1,
    }
  } catch (err) {
    reportError(err as Error)
    config.locale = 'en'
  }
  return config
}

async function loadLocalePackage(currentLanguageCode: string) {
  if (currentLanguageCode === 'en') {
    return {}
  }

  const langModules = import.meta.glob<{ default: { string: object } }>(
    '/node_modules/flatpickr/dist/esm/l10n/*.js',
  )
  const langCode = langExceptions[currentLanguageCode] || currentLanguageCode
  const languagePackage =
    await langModules[`/node_modules/flatpickr/dist/esm/l10n/${langCode}.js`]()
  return languagePackage.default[langCode]
}

const langExceptions = {
  el: 'gr',
  ca: 'cat',
}
